<template>
  <div v-show="data.report.results.length > 0" class="table-responsive">
    <table
      class="table table-condensed table-striped standard-report"
      v-show="data.report"
    >
      <thead>
        <tr class="table-header header text-left">
          <th class="text-center">
            <span class>Check#</span>
          </th>
          <th class="text-center">
            <span class>Opened</span>
          </th>
          <th class="text-center">
            <span class>By</span>
          </th>
          <th class="text-center">
            <span class>When</span>
          </th>
          <th class="text-center">
            <span class>Item</span>
          </th>
          <th class="text-center">
            <span class>Quantity</span>
          </th>
          <th class="text-right">
            <span class>Amount</span>
          </th>
          <th class="text-center">
            <span class>Reason</span>
          </th>
          <th class="text-center">
            <span class>Manager</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="border-right"
          v-for="v in data.report.results"
          :key="v.id"
          v-show="data.report.results.length > 0"
        >
          <td class="text-center">
            <sales-check-list-modal
              v-bind:locationId="[locationId]"
              v-bind:startDate="v.checkdate"
              v-bind:checkId="v.check_id"
            >{{ v.checkid }}</sales-check-list-modal>
          </td>
          <td class="text-center">{{ v.opened }}</td>
          <td class="text-center">{{ v.employee }}</td>
          <td class="text-center">{{ v.transaction_time }}</td>
          <td class="text-center">{{ v.item }}</td>
          <td class="text-center">{{ v.quantity }}</td>
          <td class="text-right">{{ v.amount | currency }}</td>
          <td class="text-center">{{ v.reason }}</td>
          <td class="text-center">{{ v.manager }}</td>
        </tr>
        <tr class="border-right" v-show="!data.report.results.length > 0">
          <td class="text-center" colspan="8">NO DATA AVAILABLE</td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="border-right">
          <td class="text-right" colspan="5">
            <strong>Totals:</strong>
          </td>
          <td class="text-center">{{ data.report.quantity }}</td>
          <td class="text-right">{{ data.report.total | currency }}</td>
          <td class="text-center">{{ data.report.pct | number }}% of sales</td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import UserService from '@/services/UserService'
import DailyJournalReportService from '@/services/DailyJournalReportService'
import DailyReportTab from './dailyReportTab'
import salesCheckListModal from '@/components/modals/sales/salesCheckListModal'

export default {
  extends: DailyReportTab,
  components: {
    salesCheckListModal
  },
  data () {
    return {
      data: {
        loading: true,
        report: {
          results: []
        }
      },
      loadTimeout: null
    }
  },
  computed: {
    grossView: function () {
      return UserService.getConfigOption('gross_sales_view').value === 'yes'
    },
    checkGuestStats: function () {
      return UserService.getConfigOption('avg_check_guest_stats').value === 'yes'
    }
  },
  methods: {
    loadData: function () {
      if (this.isActive > 0 && this.loadTimeout === null) {
        this.loadTimeout = setTimeout(() => {
          this.$updateloading(1)
          this.data.loading = true
          DailyJournalReportService.getVoidSummary(this.locationId, this.dailyDate)
            .then(res => {
              this.$updateloading(-1)
              this.data.loading = false
              this.data.report = res
              this.loadTimeout = null
            })
        }, 100)
      }
    }
  }
}
</script>
